<template>
  <div class="main">
    <div class="content">
      <div class="header">
        <p class="title">Назначенные права</p>
      </div>
      <div class="flex flex-col gap-4 w-full">
        <div
          v-for="group in filteredGroups"
          :key="group.title"
          class="rounded-xl flex flex-col"
        >
          <div
            class="w-full flex items-center gap-3 self-stretch bg-muted rounded-xl px-4 py-3 mb-3 cursor-pointer hover:bg-muted transition-colors"
            @click="toggleExpand(group)"
          >
            <svg-icon
              :name="group.isExpanded ? 'huge-up' : 'huge-down'"
              class="w-6 h-6 text-muted-foreground transition-transform duration-200"
            />
            <Checkbox
              v-model="group.selected"
              @change="toggleGroup(group)"
              @click.stop
            >
              <span class="font-medium text-base text-foreground">
                {{ group.title }}
              </span>
            </Checkbox>
          </div>
          <transition name="slide-fade">
            <div v-show="group.isExpanded" class="pl-8 flex flex-col gap-2">
              <div
                v-for="child in group.children"
                :key="child.label"
                class="flex items-center self-stretch p-0"
              >
                <Checkbox
                  v-model="child.checked"
                  @change="onChildChange(group)"
                >
                  {{ child.label }}
                </Checkbox>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "@/shared/ui/checkbox/Checkbox.vue";

export default {
  name: "OrganizationAssignedRights",
  components: { Checkbox },
  data() {
    return {
      search: "",
      groups: [
        {
          title: "Роль 1",
          selected: true,
          isExpanded: true,
          children: [
            { label: "Просмотр", checked: true },
            { label: "Редактирование", checked: true },
            { label: "Экспорт", checked: true },
            { label: "Просмотр истории", checked: false },
          ],
        },
        {
          title: "Роль 2",
          selected: true,
          isExpanded: true,
          children: [
            { label: "Просмотр", checked: true },
            { label: "Редактирование", checked: true },
            { label: "Экспорт", checked: true },
            { label: "Просмотр истории", checked: false },
          ],
        },
      ],
    };
  },
  computed: {
    filteredGroups() {
      if (!this.search) return this.groups;
      const s = this.search.toLowerCase();
      return this.groups.map((g) => ({
        ...g,
        children: g.children.filter((c) => c.label.toLowerCase().includes(s)),
      }));
    },
  },
  methods: {
    toggleExpand(group) {
      group.isExpanded = !group.isExpanded;
    },
    toggleGroup(group) {
      group.children.forEach((child) => {
        child.checked = group.selected;
      });
    },
    onChildChange(group) {
      group.selected = group.children.every((c) => c.checked);
    },
    validate() {
      return Promise.resolve(true);
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  @apply flex flex-col items-start gap-12 p-8 bg-card;
  width: 822px;
  border-radius: 20px;
  box-shadow: 0 1px 1px -0.5px rgba(0, 0, 0, 0.03),
    0 3px 3px -1.5px rgba(0, 0, 0, 0.03), 0 20px 20px -12px rgba(0, 0, 0, 0.03);
  .content {
    @apply flex flex-col items-start gap-6 self-stretch;
    .header {
      @apply flex flex-col items-start gap-3;
      .title {
        @apply text-lg font-semibold overflow-hidden;
        line-height: 24px;
        color: hsl(var(--foreground));
        text-overflow: ellipsis;
      }
    }
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
